import React, { useState, useContext, useMemo } from 'react';

export const PermissionsContext = React.createContext(null);

export const usePermissions = () => {
  const pc = useContext(PermissionsContext);
  if (pc === null) {
    throw new Error('usePermissions must be inside of PermissionsProvider');
  }
  return pc;
};

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(['user:read']);

  const value = useMemo(() => {
    return { permissions };
  }, [permissions]);

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};

// function coerceArray<T>(x: T | T[]): T[] {
// return Array.isArray(x) ? x : [x];
// }

const checkMatch = (userPermissions, canProps) => {
  let match = false;
  const { permissions = [] } = canProps;
  const permissionsArr = Array.isArray(permissions) ? permissions : [permissions];
  if (permissionsArr.length === 0) {
    match = true;
  } else {
    match = permissionsArr.some(p => userPermissions.includes(p));
  }
  return match;
};

export const Can = props => {
  const { children } = props;
  const { permissions: userPermissions } = usePermissions();
  const match = checkMatch(userPermissions, props);

  if (match) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export const Switch = ({ children }) => {
  const { permissions: userPermissions } = usePermissions();

  let element = null;
  let match = false;

  React.Children.forEach(children, child => {
    if (!match && React.isValidElement(child) && child.type === Can) {
      element = child;
      match = checkMatch(userPermissions, child.props);
    }
  });

  return match ? element : null;
};
